import * as _ from "lodash";
import { OnboardingRepo } from "@services/onboarding.repo";
import { FileItems } from "@app/onboarding/FileItems";

import * as moment from "moment";
// import { Component, Output, EventEmitter, Input, ViewChild, ElementRef } from '@angular/core';

class clientViewController implements angular.IOnInit {
  public files: FileItems[];
  public currentInput: any;
  private fileControl: HTMLInputElement;
  public clientFiles: FileItems[];
  public client: string;
  public userHash: string;
  public loginUser: boolean;
  public signinTime: Date;
  public isClientLoading = true;
  public isFileLoading = true;

  /** @ngInject */
  constructor(
    private onboardingRepo: OnboardingRepo,
    private $state: angular.ui.IStateService,
    private notifyjs: any,
    private $window: angular.IWindowService,
    private $rootScope: angular.IRootScopeService,
    private $mdDialog: angular.material.IDialogService
  ) {}

  $onInit() {
    this.performOnLoad();
    if (this.checkTimeout()) {
      this.displayLogin("otp");
    }
    this.fileControl = document.getElementById(
      "uploadFile"
    ) as HTMLInputElement;
    this.fileControl.addEventListener(
      "change",
      this.uploadFileEventChange.bind(this)
    );
    this.fileControl.addEventListener("click", this.resetInput.bind(this));
  }

  checkTimeout() {
    let now = new Date();
    let diff = (now.getTime() - this.signinTime.getTime()) / 60000;
    if (diff >= 60) {
      return true;
    }
    return false;
  }

  performOnLoad() {
    let userHash = this.$window.localStorage.getItem("user");
    if (!userHash) {
      this.displayLogin("");
    } else {
      this.userHash = userHash;
      this.client = this.$window.localStorage.getItem("user_email");
      this.signinTime = new Date(
        this.$window.localStorage.getItem("user_signin")
      );
      this.loadFileData();
      this.loadClientData();
    }
  }

  loadFileData() {
    this.isFileLoading = true;
    this.files = [];
    this.onboardingRepo
      .getOpenFiles(this.client, this.userHash)
      .then((files) => {
        this.files = files;
        this.isFileLoading = false;
      })
      .catch((err) => {
        this.displayLogin("otp");
        this.isFileLoading = false;
      });
  }

  loadClientData() {
    this.isClientLoading = true;
    this.clientFiles = [];
    this.onboardingRepo
      .getOpenClientFiles(this.client, this.userHash)
      .then((files) => {
        this.clientFiles = files;
        this.isClientLoading = false;
      })
      .catch((err) => {
        this.displayLogin("otp");
        this.isClientLoading = false;
      });
  }

  getFileName(file) {
    return file.key.split(`accountForms/`)[1];
  }

  getClientFileName(file) {
    return file.key.split(`clients/${this.client}/`)[1];
  }

  downloadFileUrl(file) {
    if (this.checkTimeout()) {
      this.displayLogin("otp");
    } else {
      this.$window.open(file.url, "_blank");
    }
  }

  openFile() {
    document.getElementById("uploadFile").click();
  }

  uploadFileEventChange(event) {
    this.isClientLoading = true;
    let file = event.target.files[0];
    this.onboardingRepo
      .uploadOpenClientFile(file, this.client, this.userHash)
      .then((res) => {
        this.loadClientData();
      })
      .catch((err) => this.displayLogin("otp"));
  }

  displayLogin(error) {
    const tempScope = this.$rootScope.$new(true) as any;
    tempScope.error = error;
    return this.$mdDialog
      .show({
        template: "<login-client error=error></login-client>",
        scope: tempScope,
      })
      .then(() => {
        this.performOnLoad();
      });
  }

  resetInput(event) {
    event.target.value = null;
    return false;
  }

  deleteFile(file) {
    this.onboardingRepo
      .deleteAnonFile(file.key, this.client, this.userHash)
      .then(() => {
        this.loadClientData();
      });
  }
}

export const clientView: angular.IComponentOptions = {
  template: require("./clientView.html"),
  controller: clientViewController,
};



// WEBPACK FOOTER //
// ./src/app/onboarding/client/clientView.ts